import Layout from "../../../../src/components/Layout";
import "../../../../src/components/ColorModeSwitcher.tsx";
import ColorModeSwitcher from "../../../../src/components/ColorModeSwitcher";
import * as React from 'react';
export default {
  Layout,
  ColorModeSwitcher,
  React
};